<form>
  <h2 mat-dialog-title class="w-100 flex justify-content-between">
    Pull Inbound Shipments
  </h2>
  <mat-dialog-content class="mat-typography">
    <h4>Specify number of days in the past to check for updates (max 365)</h4>
    <div class="row pb-8">
      <div class="col-4">
        <label class="lum-label">Days</label>
        <input
          type="number"
          [value]="this.daysPast"
          class="lum-input"
          min="1"
          max="365"
          (change)="setDays($event)"
          placeholder="Number of days"
        />
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      (click)="onCancelClick()"
      class="lum-button lum-button--secondary lum-button--medium mx-1"
    >
      Cancel
    </button>
    <button
      mat-button
      (click)="onConfirmClick($event)"
      class="lum-button lum-button--primary lum-button--medium mx-1"
    >
      Pull Shipments
    </button>
  </mat-dialog-actions>
</form>
